import type { ORG_SIZES_LABELS } from '@hotjar/webapp/features/Activation/hooks/usePersonalisation';

export type Testimonial = {
  companySize?: ORG_SIZES_LABELS;
  name: string;
  key: string;
};

type Testimonials = Testimonial[];

export const TESTIMONIALS: Testimonials = [
  {
    key: 'dmytro-k',
    name: 'Dmytro Kukuruza',
    companySize: 'org-small',
  },
  {
    key: 'andrew-h',
    name: 'Andrew Haehn',
    companySize: 'org-mid',
  },
  {
    key: 'dave-p',
    name: 'Dave Powell',
    companySize: 'org-large',
  },
  {
    key: 'anna-g',
    name: 'Anna Grunanger',
  },
  {
    key: 'piotr-s',
    name: 'Piotr Śliwa',
  },
  {
    key: 'gavin-b',
    name: 'Gavin Bell',
  },
  {
    key: 'jacob-pitcher',
    name: 'Jacob Pitcher',
  },
];
